import { render, staticRenderFns } from "./AwaySectionExportLegend.vue?vue&type=template&id=4cc6171c&scoped=true&"
import script from "./AwaySectionExportLegend.vue?vue&type=script&lang=js&"
export * from "./AwaySectionExportLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc6171c",
  null
  
)

export default component.exports